import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  noktaGetir,
  noktaGuncelle,
  noktaOlustur,
  noktaSil,
  noktalariListele,
  type NoktaGuncelleIstegi,
  type NoktaOlusturIstegi,
  type NoktaSorgusu,
  type SayfalanmisNoktalar,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

const ANAHTARLAR = {
  liste: (sorgu: Partial<NoktaSorgusu>) => ['noktalar', 'liste', sorgu] as const,
  detay: (id: string) => ['noktalar', 'detay', id] as const,
};

export function useNoktaListesi(sorgu: Partial<NoktaSorgusu>) {
  return useQuery<SayfalanmisNoktalar>({
    queryKey: ANAHTARLAR.liste(sorgu),
    queryFn: () => noktalariListele(istemci, sorgu),
    placeholderData: (onceki) => onceki,
  });
}

export function useNokta(id: string | undefined) {
  return useQuery({
    queryKey: ANAHTARLAR.detay(id ?? ''),
    queryFn: () => noktaGetir(istemci, id as string),
    enabled: !!id,
  });
}

export function useNoktaOlustur() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (giris: NoktaOlusturIstegi) => noktaOlustur(istemci, giris),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['noktalar'] }),
  });
}

export function useNoktaGuncelle(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (giris: NoktaGuncelleIstegi) => noktaGuncelle(istemci, id, giris),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['noktalar'] }),
  });
}

export function useNoktaSil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => noktaSil(istemci, id),
    onSuccess: (_, id) => {
      qc.removeQueries({ queryKey: ANAHTARLAR.detay(id) });
      qc.invalidateQueries({ queryKey: ['noktalar', 'liste'] });
    },
  });
}
